/**
 * Generated by scripts/art/pixel-broker.py: do not edit by hand. The Broker's hands (48 × 84,
 * reaching down: a skeleton's, whose middle finger is apart so it can tap; an iron hook, wet with
 * blood, and the drop it lets fall; a tentacle in three frames) and his left eye (40 × 18, and
 * 14 × 7 at the table; the right is the same, mirrored), each with its palette, run-length
 * packed (pixelPalette.ts).
 */

export interface PixelSprite {
  readonly w: number;
  readonly h: number;
  readonly palette: readonly string[];
  readonly runs: string;
}

export const HAND_PALETTE: readonly string[] = [
  '',
  '#0a0612',
  '#3c2e5e',
  '#261c40',
  '#160f28',
  '#d8ccb0',
  '#a89878',
  '#6a5c48',
  '#fff4dc',
  '#e8dcc0',
  '#bcae8e',
  '#7e6e58',
  '#4a3e32',
  '#2a2018',
  '#eef0fa',
  '#b4b6c8',
  '#7a7c92',
  '#44465a',
  '#a87048',
  '#6e4228',
  '#3e2214',
  '#ffe08a',
  '#a8762a',
  '#ff5a5a',
  '#c8102e',
  '#6a0414',
  '#e8b8f4',
  '#b47ad4',
  '#7a44a4',
  '#4a2270',
  '#2a1048',
  '#f8d8f0',
  '#8a3a7a',
];

/** His left hand: a skeleton reaching down. */
export const SKELETON: PixelSprite = {
  w: 48,
  h: 84,
  palette: HAND_PALETTE,
  runs: '124z4914214z48154z48154z481201124z47211201124z47130112214z461301134138413a4139413a1202134138413a4139413a1203124138413a4139413a1203124138413a4139413a12031221384239413941392112031341374239413842391303134138413941384239130412413841394138413a120512413841394138413a120512213841394138413a120513413741394138413a120513413741394138413a12061241374139413841392112061241374139413841391306122137413941384139130613413641394138413912071341364238413841391208124136423841384139120812213y2112081321342334233423342334211308142473247324732473241409147p5173150b13715264516g5111516151140d12511251625111516453635263511251130f165212b1541353b11153170f1ab25215b31251170k16b316b3160s12b3130112b3150s13b3130112b3120u14b316b3120t14c1b3c115b3130s13c1b5c5b3140r12c1bec1130r1281bf81120r13b1ad81130q13c1ad81140p14b1a782a4140p14c1a481a312b1a181a1c2120o14c1a48111b1a19112b19111b1a191120o13c1a49112b1a19111c1a1911181a191120n13c1a281a29112b1a19111b1a19112b191130m1381a18111b1a18112b1a18111b1a19112b191130l13c1a18111c1a19112c1a19112b1a19112b1a191120l13b1a18111b1a19112b1a19112b1a19112b1a191130j13c1a19111c1a28112b1a19112b1a19112b1a191130j13b1a18111b1a19113b1a18112b1a19112b1a281120j12c1a19112b1a19112c1a19113b1a1911283130j1281a181128312b1a2811181a29113b191130j12b18113b1a1911283138313b191120l16b1a18118b1a19113b191130o12b191130412b19213b191130n13b191130412b19213b192120n13b191130412b19213819181120n12c193120412b19213b18191120n12819281120412b192138192130m1382130412b19214b191130m12c19213041281918113819281120m12b19181120512b181911482130m12b19113051281921591130m12b19181120513b1911581120n1282130513b191180n12b181130512c193170n1291130612819281120s128113061382130s150713b191130s1508128191120z071381120z07160z08150z0z0z0z0z0z0z0z0z0z0z0i',
};

/** The skeleton's middle finger, apart, so it can tap. */
export const SKELETON_FINGER: PixelSprite = {
  w: 48,
  h: 84,
  palette: HAND_PALETTE,
  runs: '0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0m1406150x11b181110611b1a191110x1191120611b192110x1181110711b192110x130711b192110z0811b192110z0811b192110z0811b192110z0811b192110z081183110z0811b192110z0811b192110z0811b192110z0811b192110z0811b192110z0811819181110z0811b181120z08118191110z091291110z0a1181110z0a130z0z0z0z0z0z0z0z0z0z0z0q',
};

/** His right hand: an iron hook in a leather socket, wet with blood. */
export const HOOK: PixelSprite = {
  w: 48,
  h: 84,
  palette: HAND_PALETTE,
  runs: '01114z49110211214z481102124z481103114z481103114z47211103114z47120311214z461104124138413a4139413a1105114138413a4139413a1105114138413a4139413a1105114138413a4139413a11051121384239413941392111051241374239413842391206114138413941384239110711413841394138413a110711413841394138413a110711213841394138413a110712413741394138413a110811413741394138413a110811413741394138413921110811413741394138413912081121374139413841391109124136413941384139110a114136423841384139110a114136423841384139110a11213y21110a122134233423342334233421120b12247324732473247324120d127p5173130f11715264516g5111516151110h115112516251k1516453635263511251120h1552k354k353k253150m12k552ka51120r11i1kgj1110s12k2l1k5l1k5l1k2110t11k2m1k5m1k5m1k1120t11k1jei1110u11k1jei1110u11ig110u12ie120v12k1ic110x11ic120x12ia120z12h1f7120z0211e8110z0313h4130z0511h4110z0711h4110z0711h4110z0711h4110z0711h4110z0711h4110z0711h1g3110z0711h1g3110z0711h1g2f1110z0711h1n1g1f1110z0711h1n1g1f1110u130911h1n1g1f1110t12n1110911h1n1g1f1110t11n1p1120811h1n1g1f1110t11h1g1e1110811h1g2f1110t11h1f1120811h1f3110t11h1f1110911h1f3110t11h1f1110911h1f3110t11h1f1120811h1f3110t11e1f2110712h1f2e1110t12h1f1120512h1f3120u11e1f217h1f3e1110v12e1f1h2f111h3f3e1120w12nae1120y13n1p6130z0214o1140z0711p1110z0a130z0z0z0z0z0z0z0z0z0z0z0z0z0z0j',
};

/** Where the hook's blood gathers and falls from, in its pixels. */
export const HOOK_DRIP = { x: 17, y: 72 } as const;

/** A drop of blood. */
export const DROP: PixelSprite = {
  w: 3,
  h: 4,
  palette: HAND_PALETTE,
  runs: '01n101n1o4p101p101',
};

/** A tentacle instead of a hand, in three frames of a wriggle. */
export const TENTACLE: readonly PixelSprite[] = [
  {
    w: 48,
    h: 84,
    palette: HAND_PALETTE,
    runs: '01114z49110211214z481102124z481103114z481103114z47211103114z47120311214z461104124138413a4139413a1105114138413a4139413a1105114138413a4139413a1105114138413a4139413a11051121384239413941392111051241374239413842391206114138413941384239110711413841394138413a110711413841394138413a110711213841394138413a110712413741394138413a110811413741394138413a110811413741394138413921110811413741394138413912081121374139413841391109124136413941384139110a114136423841384139110a114136423841384139110a11213y21110a122134233423342334233421120b12247324732473247324120d127p5173130f11715264516g5111516151110h11511251625111516453635263511251120h155212t154t353t1u153150m15q1t152t7v1t11151120u12t2q1t6v1w1v1130w11q1tb120x12tav1u1110y11q1s2q1s5v1w1v1110y12q1sa110z12t1s9110z0111q1s8v1120z12t1q1s5v1w1v1110z0111t1s8r1110z0111q1s8q1110z0112t1s5v1r1120z0211t1q1s3v1w1v1110z0311t1s6r1110z0212t1s4v1s1q1110z0211u1s1q1s2v1w1v1120z0112t1s6q1110z0211u1s6r1120z0112t1s4v1s1q1110z0112u1s2q1s1v1w1v1120z0111u1r6q1120z0112t1r2v1r2q1120z0112u1r1q1v1w1v1q1120z0211u1r5q1120z0212t1r4q1120z0311u1r2v1r1q1120z0312t1r1v1w1v1120z0411u1r3q1120z0412t1r2q1120z0511u1r2q1120z0611t1r1q1130z0611t1r1q3120z0511t1r113r1120z0411q1r1110111t1r1110z0412r113t1q1110z0511q1r111u1q1120z0512q3120z07150z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0y',
  },
  {
    w: 48,
    h: 84,
    palette: HAND_PALETTE,
    runs: '01114z49110211214z481102124z481103114z481103114z47211103114z47120311214z461104124138413a4139413a1105114138413a4139413a1105114138413a4139413a1105114138413a4139413a11051121384239413941392111051241374239413842391206114138413941384239110711413841394138413a110711413841394138413a110711213841394138413a110712413741394138413a110811413741394138413a110811413741394138413921110811413741394138413912081121374139413841391109124136413941384139110a114136423841384139110a114136423841384139110a11213y21110a122134233423342334233421120b12247324732473247324120d127p5173130f11715264516g5111516151110h11511251625111516453635263511251120h15521354t353t253150m14011252t8v1t151120w11q1t1q1t6v1w1v1120x12tb110z11q1t8v1t1110z12t1q1s5v1w1v1110z0111t1s9110z0111t1s9110z0111t1s7v1s1110z0111t1s1q1s4v1w1v1110z12t1s7r1120z11u1s8q1110z12t1s6v1r1120z11u1s2q1s3v1w1v1110z12t1s7r1120z11u1s5v1s2q1110z12t1s1q1s2v1w1v1q1120z11u1s7q1120z12t1s6q1120z0111u1s4v1s1q1120z0112t1s1q1s1v1w1v1120z0211u1r6120z0212t1r2v1r2q1110z0311u1r1q1v1w1v1q1120z0311t1r4q1120z0411t1r4120z0511t1r2v1r1110z0611t1r1v1w1v1110z0611q1r3120z0612t1r2120z0711q1r3110z0712t1q1r1160z0311q1r312q1r1120z0212q1r213q1r1110z0312q1r213r1110z0412q1r113r1110z0512q1r111u1q1110z0612q3120z07150z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0t',
  },
  {
    w: 48,
    h: 84,
    palette: HAND_PALETTE,
    runs: '01114z49110211214z481102124z481103114z481103114z47211103114z47120311214z461104124138413a4139413a1105114138413a4139413a1105114138413a4139413a1105114138413a4139413a11051121384239413941392111051241374239413842391206114138413941384239110711413841394138413a110711413841394138413a110711213841394138413a110712413741394138413a110811413741394138413a110811413741394138413921110811413741394138413912081121374139413841391109124136413941384139110a114136423841384139110a114136423841384139110a11213y21110a122134233423342334233421120b12247324732473247324120d127p5173130f11715264516g5111516151110h11511251625111516453635263511251120h15521354t353t253150m14011252t8v1t151120w11t2q1t6v1w1v1120x11tbq1110y11t9v1t1120y11t1s1q1s5v1w1v1110y12t1s9q1110y11u1sa120x12t1s7v1s1q1110y11u1s2q1s4v1w1v1120y11t1s9q1110y12t1s8q1120y11u1s6v1s1q1120y12t1s1q1s3v1w1v1120z11u1s8q1110z0111t1s5v1s1q1120z0111t1s1q1s2v1w1v1120z0112t1s5r1120z0211u1s6q1110z0311t1s4v1r1120z0311t1s1q1s1v1w1v1110z0411q1r5120z0412t1r3v1110z0611t1q1r1v1w1120z0511q1r5110z0512t1r4120z0511q1r3v1r1110z0512q1r1v1w1v1120z0512q1r4120z0512q1r4120z0512q1r4110z0612q2r21201140z0112q2r213q1r1120z0113q1r213q1r1110z0312q1r213r1110z0412q1r113r1110z0512q1r111u1q1110z0612q3120z07150z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0z0m',
  },
];

export const EYE_PALETTE: readonly string[] = [
  '',
  '#0c0206',
  '#d8b878',
  '#9a6a3a',
  '#5a3018',
  '#2a1008',
  '#fff2a0',
  '#ffb02a',
  '#e0501a',
  '#8a160c',
  '#050002',
  '#fffbe8',
  '#5a1a10',
];

export const EYE: PixelSprite = {
  w: 40,
  h: 18,
  palette: EYE_PALETTE,
  runs: '0z0z0z0o180p1l0h1a561b0d1357352196180a1152453621918272a29416081342c2362291817261a2617281915215081243c4322291817162a26271819122521507134134c22291817162a262718191233152170512362291817261a2617281912331c2521506133521918272a27282912234c2521308143321918271a271829122c333140d1332219182a282912233c1140i1592a29233150p1b0z0h',
};

/** His eye, small, at the table. */
export const EYE_SMALL: PixelSprite = {
  w: 14,
  h: 7,
  palette: EYE_PALETTE,
  runs: '0e1a041c021142329171a17118328161a1719121130212319171a181213212031a01',
};
